import React from "react";
import { View, Text, ImageBackground } from "react-native";
import { EStyleSheet, useDynamicStyles } from "react-native-extended-stylesheet-typescript";
import { useServices } from "../../contexts/ServiceContext";
import { MediaQueries } from "../hooks/dynamicStyleHook";
import { GlobalStyles } from "../style/Style";

type Props = {
    title: string;
    date?: string;
    optionalText?: string;
    backgroundImage?: string;
    reviewPicksState?: boolean;
};

export const GameTitle: React.FC<Props> = ({
    title,
    date,
    optionalText,
    backgroundImage,
    reviewPicksState = false,
}) => {
    const { edgeDeploy } = useServices();
    const styles = useDynamicStyles(generateStyles);

    return (
        <View style={edgeDeploy ? styles.edgeGameContainer : styles.gameContainer}>
            {edgeDeploy && (
                <ImageBackground source={{ uri: backgroundImage }} style={styles.background}>
                    <div className="gameButtonGradient edge">
                        <Text testID={"title"} style={[styles.title, styles.edgeTitle]}>
                            {title}
                        </Text>
                        {date && (
                            <Text testID={"subTitle"} style={[styles.subTitle, styles.edgeSubTitle]}>
                                {date}
                            </Text>
                        )}
                        {optionalText && reviewPicksState === false && (
                            <Text testID={"optional"} style={[styles.text, styles.edgeText]}>
                                {optionalText}
                            </Text>
                        )}
                    </div>
                </ImageBackground>
            )}
            {!edgeDeploy && (
                <>
                    <Text testID={"subTitle"} style={styles.subTitle}>
                        {date}
                    </Text>
                    {optionalText && reviewPicksState === false && (
                        <Text testID={"optional"} style={[styles.text]}>
                            {optionalText}
                        </Text>
                    )}
                </>
            )}
        </View>
    );
};

const generateStyles = () => {
    return EStyleSheet.create({
        [MediaQueries.SMALL]: {
            edgeGameContainer: {
                height: 180,
            },
            edgeTitle: {
                fontSize: 32,
            },
            edgeSubTitle: {
                fontSize: 14,
            },
            edgeText: {
                fontSize: 12,
            },
        },
        edgeGameContainer: {
            width: "100%",
            height: 200,
            marginBottom: 20,
            borderRadius: () => EStyleSheet.value(GlobalStyles.BORDER_RADIUS),
            overflow: "hidden",
        },
        gameContainer: {
            alignContent: "center",
            justifyContent: "center",
            textAlign: "center",
            width: "100%",
            paddingHorizontal: 10,
            marginBottom: 5,
        },
        title: {
            fontSize: 32,
            lineHeight: 32,
            margin: 0,
            width: "100%",
            textAlign: "center",
            fontFamily: () => EStyleSheet.value(GlobalStyles.HEADER_FONT),
            color: () => EStyleSheet.value(GlobalStyles.ACCENT_COLOUR),
        },
        subTitle: {
            fontSize: 13,
            lineHeight: 13,
            fontWeight: "600",
            width: "100%",
            textAlign: "center",
            marginBottom: 5,
            fontFamily: () => EStyleSheet.value(GlobalStyles.BASE_FONT),
            color: () => EStyleSheet.value(GlobalStyles.BASE_COLOUR),
        },
        text: {
            fontSize: 12,
            lineHeight: 16,
            fontWeight: "400",
            width: "100%",
            textAlign: "center",
            margin: 0,
            paddingHorizontal: 10,
            fontFamily: () => EStyleSheet.value(GlobalStyles.BASE_FONT),
            color: () => EStyleSheet.value(GlobalStyles.BASE_COLOUR),
        },
        edgeTitle: {
            color: () => EStyleSheet.value(GlobalStyles.EDGE_GAME_TITLE_TEXT),
            fontSize: 40,
            lineHeight: 40,
            marginBottom: 9,
        },
        edgeSubTitle: {
            color: () => EStyleSheet.value(GlobalStyles.EDGE_GAME_SUBTITLE_TEXT),
            fontSize: 18,
            fontWeight: "600",
            lineHeight: 18,
        },
        edgeText: {
            color: () => EStyleSheet.value(GlobalStyles.EDGE_GAME_TEXT),
            fontSize: 14,
            fontWeight: "400",
        },
        background: {
            height: "100%",
            borderRadius: () => EStyleSheet.value(GlobalStyles.BORDER_RADIUS),
            overflow: "hidden",
        },
    });
};
